module.exports = __webpack_public_path__ + "img/Icon_disciplina_hover.645e9059.svg";